import axios from "axios";

class DataManager
{
    constructor(serverURL) {
        this.serverURL = serverURL;
    }

    async validateManual(emailAddress, confirmationCode) {
        let formData = new FormData();
        formData.append("EmailAddress", emailAddress);
        formData.append("ConfirmationCode", confirmationCode);

        return await axios.post(this.serverURL + "/register-api/validate", formData)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
                /*
                if (typeof error.response.data !== "undefined")
                {
                    return error.response.data;
                }
                 */
            });
    }

    async validateAuto(personID, confirmationCode) {
        let formData = new FormData();
        formData.append("PersonID", personID);
        formData.append("ConfirmationCode", confirmationCode);

        return await axios.post(this.serverURL + "/register-api/validate", formData)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }


    async resendEmail(emailAddress, firstName, lastName) {
        let formData = new FormData();
        formData.append("FirstName", firstName);
        formData.append("LastName", lastName)
        formData.append("EmailAddress", emailAddress);

        return await axios.post(this.serverURL + "/register-api/resend", formData)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }

    async submit(jwt, croppedPhoto, password)
    {
        console.log(jwt);
        console.log(croppedPhoto);
        console.log(password);

        let fileName = "photo.png";
        if (croppedPhoto.type === "image/jpeg")
        {
            fileName = "photo.jpg";
        }

        let formData = new FormData();
        formData.append("jwt", jwt);
        formData.append("PhotoFile", croppedPhoto, fileName);
        formData.append("Password", password);

        return await axios.post(this.serverURL + "/register-api/submit", formData)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                if (error.response) {
                    return error.response;
                }
                else if (error.request) {
                    return error.request;
                }
                else {
                    return error.message;
                }
            });
    }

}

export default DataManager;